export default () => ({
  isShown: false,
  typeModal: '',
  paymentMethodId: '',
  errors: {},
  errorsMessages: {},
  paymentMethodBonuses: [],
});
